import { inApp as isBbqApp, initBridge as initBbqBridge } from '@bilibili-bbq/razor';
import { getRandomString, getVersion } from './utils';
if (isBbqApp) {
    initBbqBridge();
}
var UA = window.navigator.userAgent;
var isWechat = /MicroMessenger/i.test(UA);
var isQQ = /QQ\/([\d.]+)/.test(UA);
var isIos = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(UA);
var isIphone = /(iPhone\sOS)\s([\d_]+)/i.test(UA);
var isAndroid = /(Android);?[\s/]+([\d.]+)?/i.test(UA);
var isUCBrowser = /ucweb|UCBrowser/i.test(UA);
var isQQMBrowser = /MQQBrowser/i.test(UA) && !isWechat && !isQQ;
var ucVersion = isUCBrowser ? getVersion(/UCBrowser\/(\d+\.\d*)/i) : 0;
var isUC = isUCBrowser &&
    ((ucVersion > 10.2 && isIphone) || (ucVersion > 9.7 && isAndroid));
export default {
    shareConfig: {
        title: document.title || '哔哩哔哩弹幕视频网',
        desc: '哔哩哔哩弹幕视频网 - ( ゜- ゜)つロ  乾杯~ ',
        link: window.location.href,
        pics: 'https://static.hdslb.com/mobile/img/app_logo.png',
        type: 'web',
        isMpc: true,
        biz_type: 3,
        font_size: 100,
        change_share: false,
        bili: {
            text_area: ''
        },
        weibo: {},
        qq: {},
        qzone: {},
        weixin: {},
        weixin_moment: {},
        baidu_tieba: {},
        success: function (info) {
            console.log('success: ', info);
        },
        cancel: function (info) {
            console.log('cancel: ', info);
        }
    },
    channel: [
        {
            name: 'weibo',
            title: '新浪微博',
            link: 'https://service.weibo.com/share/share.php?appkey=2841902482&language=zh_cn&',
            toApp: ['kSinaWeibo', 'SinaWeibo', 11],
            wxApi: 'onMenuShareWeibo'
        },
        {
            name: 'qzone',
            title: 'QQ空间',
            link: 'https://h5.qzone.qq.com/q/qzs/open/connect/widget/mobile/qzshare/index.html?',
            toApp: ['kQZone', 'QZone', 3],
            wxApi: 'onMenuShareQZone',
            scheme: isIos
                ? 'mqqapi://share/to_fri?file_type=news&src_type=web&version=1&generalpastboard=1&shareType=1&cflag=1&objectlocation=pasteboard&callback_type=scheme&callback_name=QQ41AF4B2A'
                : 'mqqapi://share/to_qzone?src_type=app&version=1&file_type=news&req_type=1'
        },
        {
            name: 'qq',
            title: 'QQ好友',
            link: 'https://connect.qq.com/widget/shareqq/index.html?',
            toApp: ['kQQ', 'QQ', 4],
            wxApi: 'onMenuShareQQ',
            scheme: 'mqqapi://share/to_fri?src_type=web&version=1&file_type=news'
        },
        {
            name: 'baidu_tieba',
            title: '百度贴吧',
            link: 'https://tieba.baidu.com/f/commit/share/openShareApi?'
        },
        {
            name: 'bili',
            title: '动态',
            link: 'javascript:void(0)'
        },
        {
            name: 'weixin',
            title: '微信好友',
            toApp: ['kWeixin', 'WechatFriends', 1],
            wxApi: 'onMenuShareAppMessage'
        },
        {
            name: 'weixin_moment',
            title: '朋友圈',
            wxApi: 'onMenuShareTimeline',
            toApp: ['kWeixinFriend', 'WechatTimeline', 8]
        },
        {
            name: 'more',
            title: '其它'
        },
        {
            name: 'copy_link',
            title: '复制链接'
        }
    ],
    wechatConfig: {
        wxconfigappid: 'wx108457cda8a1b9f9',
        timestamp: Date.now() / 1000,
        jsApiList: [
            'showOptionMenu',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone'
        ],
        nonceStr: getRandomString(32)
    },
    browser: {
        isWechat: isWechat,
        isQQ: isQQ,
        isUC: isUC,
        isIos: isIos,
        isUCBrowser: isUCBrowser,
        isQQMBrowser: isQQMBrowser,
        ucVersion: ucVersion,
        isIphone: isIphone,
        isAndroid: isAndroid,
        isIpod: /(iPod)(.*OS\s([\d_]+))?/i.test(UA),
        isIpad: /(iPad).*OS\s([\d_]+)/i.test(UA),
        isPad: /PAD|pad/i.test(UA),
        isQZone: /Qzone\//i.test(UA),
        isBaiduApp: /baiduboxapp/i.test(UA),
        isSafari: isIos && /Safari\//i.test(UA) && !isQQ && !isUCBrowser && !isQQMBrowser,
        qqVersion: isQQMBrowser ? getVersion(/MQQBrowser\/(\d+\.\d*)/i) : 0,
        isBiliApp: /BiliApp\/\d+/i.test(UA),
        isBbqApp: isBbqApp,
        biliVersion: UA.match(/BiliApp\/([^ ]*)/)
            ? (Number(UA.match(/BiliApp\/([^ ]*)/)[1]) || 0)
            : 0,
        hasMangaMallSdk: /mallSdkVersion/i.test(UA),
        biliMangaMallSdkVersion: UA.match(/mallSdkVersion\/([^ ]*)/)
            ? (Number(UA.match(/mallSdkVersion\/([^ ]*)/)[1]) || 0)
            : 0,
    }
};
